import MUIFonts from './MUIFonts';

import lightTheme from '../components/style/lightTheme';

const MuiTable = {
  styleOverrides: {
    root: {
      color: lightTheme.textPrimary,
      backgroundColor: lightTheme.bg,
      border: 'none',

      '& .MuiTableHead-root': {
        ...MUIFonts.tableHeader,
      },
      '& .MuiTableCell-head': {
        boxSizing: 'border-box',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        padding: '16px',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 500,
        letterSpacing: '0.17px',
        ...MUIFonts.tableHeader,
      },

      '& .MuiTableCell-body': {
        boxSizing: 'border-box',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        fontWeight: 400,
        padding: '16px',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.17px',
      },
      '& .MuiTableCell-footer': {
        fontFamily: 'Noto Sans',
        boxSizing: 'border-box',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        fontWeight: 500,
        padding: '6px 32px',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.17px',
      },
    },
  },
};
export default MuiTable;
